import * as React from 'react';
import LogoPic from "../Assets/Images/logo.png";
import API from "../Services/API";
import EmptyPic from "../Assets/Images/emptypic.png";

export default function Header() {

    const [user, setUser] = React.useState([]);

    const onExitClick = () => {
        localStorage.clear();
        document.cookie = "auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.replace("/")
    }


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (!token) {
            window.location.replace('/login')
        }

        API.getUserInfo()
            .then((response) => {
                window.localStorage.setItem("spr",  JSON.stringify(response.data.user.s_permissions));

                setUser(response.data.user);
            })
            .catch((error) => {

            });


    }, []);
    return (
        <React.Fragment>
            <header id="header" className="header fixed-top d-flex align-items-center  rtl">

                <div className="d-flex align-items-center justify-content-between">
                    <a href="https://www.ngkh.ir/" target="_blank"  rel="noreferrer"  className="logo d-flex align-items-center">
                        <img src={LogoPic} alt="Logo" className='not-show-mobile' />
                        <span className="d-none d-lg-block mx-2 text-small-2">NGKH</span>
                        <span className=' d-none d-lg-block   text-small-3 text-muted opacity-75'>
                            سامانه فروش
                        </span>
                    </a>
                    <i className="bi bi-list toggle-sidebar-btn"
                    onClick={() =>{
                        document.getElementsByTagName('body')[0].classList.toggle('toggle-sidebar')
                    }}

                    ></i>
                </div>
                <nav className="header-nav position-absolute left-0 ">
                    <ul className="d-flex align-items-center">



                        <li className="nav-item dropdown pe-3">

                            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown" title={user.name
                                + ' ' + user.surname}>
                                <img  src={user.avatar  ? user.avatar : EmptyPic } alt="Profile" className="rounded-circle" />
                                <span className="d-none d-md-block dropdown-toggle ps-2 mx-2 text-small-2">

                                </span>
                            </a>

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile text-small-2">
                                <li className="dropdown-header">
                                    <h6>      {user.name}
                                        &nbsp;

                                        {user.surname}</h6>
                                    <span>{user.username}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-person mx-2"></i>
                                        <span>ویرایش پروفایل</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="pages-faq.html">
                                        <i className="bi bi-question-circle mx-2"></i>
                                        <span>راهنمای سامانه</span>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center"
                                       onClick={onExitClick} role='button'
                                    >
                                        <i className="bi bi-box-arrow-right mx-2"></i>
                                        <span>خروج از سامانه</span>
                                    </a>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </nav>


            </header>
        </React.Fragment>
    );
};